(function () {
  var STORAGE_PREFIX = 'claymore-cart-proof:';
  var MAX_AGE = 30 * 24 * 60 * 60 * 1000;
  var renderQueued = false;
  var lightbox = null;
  var lightboxImage = null;
  var lightboxTitle = null;
  var lightboxReturnFocus = null;
  var viewerCounter = 0;

  function storageKey(setupId) {
    return STORAGE_PREFIX + setupId;
  }

  function removeExpiredProofs() {
    var now = Date.now();

    try {
      for (var index = window.localStorage.length - 1; index >= 0; index -= 1) {
        var key = window.localStorage.key(index);
        var stored;

        if (!key || key.indexOf(STORAGE_PREFIX) !== 0) continue;
        stored = JSON.parse(window.localStorage.getItem(key) || '{}');
        if (!stored.savedAt || now - stored.savedAt > MAX_AGE) window.localStorage.removeItem(key);
      }
    } catch (error) {
      // The product thumbnail remains available when browser storage is restricted.
    }
  }

  function save(setupId, proofs) {
    if (!setupId || !proofs || (!proofs.front && !proofs.back)) return;

    try {
      removeExpiredProofs();
      window.localStorage.setItem(
        storageKey(setupId),
        JSON.stringify({
          front: proofs.front || '',
          back: proofs.back || '',
          savedAt: Date.now(),
        })
      );
    } catch (error) {
      // Storage limits should never prevent the shirt from being added to the cart.
    }
  }

  function read(setupId) {
    try {
      return JSON.parse(window.localStorage.getItem(storageKey(setupId)) || 'null');
    } catch (error) {
      return null;
    }
  }

  function getSideName(side) {
    return side === 'back' ? 'Back' : 'Front';
  }

  function getProof(container, setupId) {
    var storedProof = read(setupId) || {};

    return {
      front: container.dataset.claymoreProofFront || storedProof.front || '',
      back: container.dataset.claymoreProofBack || storedProof.back || '',
      location: container.dataset.claymorePrintLocation || '',
    };
  }

  function createSwitcherButton(side, panelId, switcherId) {
    var button = document.createElement('button');

    button.className = 'cm-cart-proof__switch';
    button.type = 'button';
    button.id = switcherId + '-' + side;
    button.dataset.claymoreProofSwitch = side;
    button.setAttribute('role', 'tab');
    button.setAttribute('aria-controls', panelId);
    button.setAttribute('aria-selected', 'false');
    button.tabIndex = -1;
    button.textContent = getSideName(side);
    return button;
  }

  function activateProofSide(viewer, requestedSide) {
    var frontSrc = viewer.dataset.claymoreProofFront || '';
    var backSrc = viewer.dataset.claymoreProofBack || '';
    var side = requestedSide === 'back' && backSrc ? 'back' : frontSrc ? 'front' : 'back';
    var src = side === 'back' ? backSrc : frontSrc;
    var image = viewer.querySelector('[data-claymore-proof-image]');
    var previewButton = viewer.querySelector('[data-claymore-proof-open]');
    var sideLabel = viewer.querySelector('[data-claymore-proof-label]');
    var panel = viewer.querySelector('[role="tabpanel"]');

    if (!src || !image || !previewButton) return;
    viewer.dataset.claymoreProofActiveSide = side;
    image.src = src;
    image.alt = 'Saved ' + side + ' placement proof';
    previewButton.dataset.claymoreProofSide = side;
    previewButton.setAttribute('aria-label', 'Enlarge saved ' + side + ' placement proof');
    if (sideLabel) sideLabel.textContent = getSideName(side) + ' proof';

    viewer.querySelectorAll('[data-claymore-proof-switch]').forEach(function (button) {
      var isActive = button.dataset.claymoreProofSwitch === side;
      button.classList.toggle('is-active', isActive);
      button.setAttribute('aria-selected', String(isActive));
      button.tabIndex = isActive ? 0 : -1;
      if (isActive && panel) panel.setAttribute('aria-labelledby', button.id);
    });
  }

  function createProofViewer(proof, setupId, originalImage) {
    var viewer = document.createElement('div');
    var header = document.createElement('div');
    var heading = document.createElement('div');
    var eyebrow = document.createElement('span');
    var location = document.createElement('strong');
    var saved = document.createElement('span');
    var panel = document.createElement('div');
    var previewButton = document.createElement('button');
    var previewFooter = document.createElement('span');
    var sideLabel = document.createElement('strong');
    var hint = document.createElement('span');
    var panelId;
    var switcherId;
    var switcher;
    var initialSide = proof.front ? 'front' : 'back';

    viewerCounter += 1;
    panelId = 'ClaymoreCartProofPanel-' + viewerCounter;
    switcherId = 'ClaymoreCartProofTab-' + viewerCounter;
    viewer.className = 'cm-cart-proof__viewer';
    viewer.dataset.claymoreProofFront = proof.front || '';
    viewer.dataset.claymoreProofBack = proof.back || '';
    viewer.dataset.claymoreSetupId = setupId;

    header.className = 'cm-cart-proof__header';
    heading.className = 'cm-cart-proof__heading';
    eyebrow.className = 'cm-cart-proof__eyebrow';
    eyebrow.textContent = 'Your placement proof';
    location.className = 'cm-cart-proof__location';
    location.textContent = proof.location || (proof.front && proof.back ? 'Front + back' : proof.back ? 'Back only' : 'Front only');
    saved.className = 'cm-cart-proof__status';
    saved.textContent = 'Saved';
    heading.appendChild(eyebrow);
    heading.appendChild(location);
    header.appendChild(heading);
    header.appendChild(saved);
    viewer.appendChild(header);

    if (proof.front && proof.back) {
      switcher = document.createElement('div');
      switcher.className = 'cm-cart-proof__switcher';
      switcher.setAttribute('role', 'tablist');
      switcher.setAttribute('aria-label', 'Choose placement proof side');
      switcher.appendChild(createSwitcherButton('front', panelId, switcherId));
      switcher.appendChild(createSwitcherButton('back', panelId, switcherId));
      viewer.appendChild(switcher);
      viewer.classList.add('cm-cart-proof__viewer--two-sided');
    }

    panel.className = 'cm-cart-proof__panel';
    panel.id = panelId;
    panel.setAttribute('role', 'tabpanel');
    previewButton.className = 'cm-cart-proof__preview';
    previewButton.type = 'button';
    previewButton.dataset.claymoreProofOpen = '';
    originalImage.className = 'cart-item__image cm-cart-proof__image';
    originalImage.removeAttribute('srcset');
    originalImage.loading = 'lazy';
    originalImage.width = 600;
    originalImage.height = 600;
    originalImage.dataset.claymoreProofImage = '';
    previewFooter.className = 'cm-cart-proof__preview-footer';
    sideLabel.dataset.claymoreProofLabel = '';
    hint.className = 'cm-cart-proof__hint';
    hint.textContent = 'View larger';
    previewFooter.appendChild(sideLabel);
    previewFooter.appendChild(hint);
    previewButton.appendChild(originalImage);
    previewButton.appendChild(previewFooter);
    panel.appendChild(previewButton);
    viewer.appendChild(panel);
    activateProofSide(viewer, initialSide);
    return viewer;
  }

  function ensureLightbox() {
    var backdrop;
    var dialog;
    var closeButton;

    if (lightbox) return;
    lightbox = document.createElement('div');
    lightbox.className = 'cm-proof-lightbox';
    lightbox.hidden = true;
    lightbox.setAttribute('role', 'dialog');
    lightbox.setAttribute('aria-modal', 'true');
    lightbox.setAttribute('aria-labelledby', 'ClaymoreProofLightboxTitle');

    backdrop = document.createElement('button');
    backdrop.className = 'cm-proof-lightbox__backdrop';
    backdrop.type = 'button';
    backdrop.setAttribute('aria-label', 'Close enlarged placement proof');
    backdrop.dataset.claymoreProofClose = '';

    dialog = document.createElement('div');
    dialog.className = 'cm-proof-lightbox__dialog';
    lightboxTitle = document.createElement('h2');
    lightboxTitle.id = 'ClaymoreProofLightboxTitle';
    lightboxTitle.className = 'cm-proof-lightbox__title';
    closeButton = document.createElement('button');
    closeButton.className = 'cm-proof-lightbox__close';
    closeButton.type = 'button';
    closeButton.setAttribute('aria-label', 'Close enlarged placement proof');
    closeButton.dataset.claymoreProofClose = '';
    closeButton.textContent = '\u00d7';
    lightboxImage = document.createElement('img');
    lightboxImage.className = 'cm-proof-lightbox__image';

    dialog.appendChild(closeButton);
    dialog.appendChild(lightboxTitle);
    dialog.appendChild(lightboxImage);
    lightbox.appendChild(backdrop);
    lightbox.appendChild(dialog);
    document.body.appendChild(lightbox);
  }

  function openLightbox(button) {
    var image = button.querySelector('img');
    var side = button.dataset.claymoreProofSide || 'front';

    if (!image) return;
    ensureLightbox();
    lightboxReturnFocus = button;
    lightboxTitle.textContent = getSideName(side) + ' placement proof';
    lightboxImage.src = image.src;
    lightboxImage.alt = image.alt;
    lightbox.hidden = false;
    document.body.classList.add('cm-proof-lightbox-open');
    lightbox.querySelector('.cm-proof-lightbox__close').focus();
  }

  function closeLightbox() {
    if (!lightbox || lightbox.hidden) return;
    lightbox.hidden = true;
    document.body.classList.remove('cm-proof-lightbox-open');
    if (lightboxReturnFocus) lightboxReturnFocus.focus();
  }

  function renderContainer(container) {
    var setupId = container.dataset.claymoreSetupId;
    var proof = getProof(container, setupId);
    var originalImage = container.querySelector('[data-claymore-cart-proof-front]');

    if ((!proof.front && !proof.back) || !originalImage) return;
    if (container.dataset.claymoreProofRendered === setupId) return;
    container.replaceChildren(createProofViewer(proof, setupId, originalImage));
    container.classList.add('cm-cart-proof--ready');
    container.dataset.claymoreProofRendered = setupId;
  }

  function render() {
    document.querySelectorAll('[data-claymore-cart-proof]').forEach(renderContainer);
  }

  function queueRender() {
    if (renderQueued) return;
    renderQueued = true;
    window.requestAnimationFrame(function () {
      renderQueued = false;
      render();
    });
  }

  window.ClaymoreCartProofs = {
    save: save,
    render: render,
  };

  removeExpiredProofs();
  document.addEventListener('click', function (event) {
    var target = event.target instanceof Element ? event.target : null;
    var switchButton = target ? target.closest('[data-claymore-proof-switch]') : null;
    var openButton = target ? target.closest('[data-claymore-proof-open]') : null;
    var closeButton = target ? target.closest('[data-claymore-proof-close]') : null;

    if (switchButton) {
      event.preventDefault();
      activateProofSide(switchButton.closest('.cm-cart-proof__viewer'), switchButton.dataset.claymoreProofSwitch);
    } else if (openButton) {
      event.preventDefault();
      openLightbox(openButton);
    } else if (closeButton) {
      closeLightbox();
    }
  });
  document.addEventListener('keydown', function (event) {
    var target = event.target instanceof Element ? event.target : null;
    var switchButton = target ? target.closest('[data-claymore-proof-switch]') : null;
    var switcher;
    var buttons;
    var currentIndex;
    var nextIndex;

    if (event.key === 'Escape') {
      closeLightbox();
      return;
    }
    if (!switchButton || (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight')) return;
    switcher = switchButton.closest('[role="tablist"]');
    buttons = Array.prototype.slice.call(switcher.querySelectorAll('[data-claymore-proof-switch]'));
    currentIndex = buttons.indexOf(switchButton);
    nextIndex = event.key === 'ArrowRight' ? (currentIndex + 1) % buttons.length : (currentIndex - 1 + buttons.length) % buttons.length;
    event.preventDefault();
    activateProofSide(buttons[nextIndex].closest('.cm-cart-proof__viewer'), buttons[nextIndex].dataset.claymoreProofSwitch);
    buttons[nextIndex].focus();
  });
  queueRender();
  new MutationObserver(queueRender).observe(document.documentElement, { childList: true, subtree: true });
})();
